import { PurlDobVerificationScreen } from '@/components/AccountCreationScreen';

export default function PurlDobVerification() {
  return <PurlDobVerificationScreen />;
}
